import { Outlet, useLocation } from "react-router-dom";
import * as React from "react";
import Header from "./header";
import Aside from "./aside";
import Footer from "./footer";

const EXCEPT_HEADER = ["/login", "/error/403"]

export default function Layout() {
  const location = useLocation();
  const shouldHide = EXCEPT_HEADER.includes(location.pathname);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex h-screen w-full overflow-hidden">
      {!shouldHide && (
        <div className="h-full shrink-0">
          <Aside />
        </div>
      )}

      <div className="prevent-back-swipe h-full flex-1 overflow-auto custom-scrollbar">
        <div className="flex min-h-full min-w-[1200px] flex-col">
          {!shouldHide && (
            <header className="sticky top-0 z-10 shrink-0">
              <Header />
            </header>
          )}

          <main className="flex-1">
            <div className="flex min-h-full flex-col">
              <Outlet />

              {!shouldHide && <div className="mt-auto shrink-0"><Footer /></div>}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
